import { endpoints } from "@/api/endpoints/endpoints";
import { deletePickup, getPickup } from "@/api/pickup-api";
import { useCollectionData, useMutation } from "@/hooks/use-api";

export function useGetPickup(id: string) {
  const cacheKey = endpoints.pickup.get(id);

  return useCollectionData(cacheKey, () => getPickup(id), {
    refreshInterval: 0,
    revalidateOnFocus: false,
  });
}

export function useDeletePickup() {
  return useMutation(deletePickup, {
    onSuccess: (response) => {
      console.log("Pickup deleted successfully:", response.data);
    },
    onError: (error) => {
      console.error("Error deleting Pickup:", error);
    },
  });
}
